import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import edit from "../../../assets/images/edit.png";
import trash from "../../../assets/images/trash.png";
import BellR from "../../../assets/images/bell_de.png";
import BellG from "../../../assets/images/bell_flt.png";
import MailR from "../../../assets/images/mail_dlt.png";
import MailG from "../../../assets/images/mail_at.png";
import Userview from "../../../assets/images/useer_view.png";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { withToken, withRFSToken } from '../../../Services/axios.js';
import { USERDELETE, AIRLINEUSER, AIRLINESTATION, AIRLINESAVEUSER, AIRLINEREMOVEUSER } from '../../../Utils/conts.js';

const StationSettings = ({ isModal, ruleId }) => {

  const isMounted = useRef(false);
  const [modalShow, setModalShow] = useState(false);
  const [editId, setEditId] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteFunction, setDeleteFunction] = useState(null);
  const userRole = [
    { label: 'User', value: 'E' },
    { label: 'Admin', value: 'S' },
    // {label: 'Company Super Admin', value: 'SA'}
  ];

  const handleAddButtonClick = () => {

    setModalShow(true);
  };
  const handleEditButtonClick = (userId) => {
    setEditId(userId);
    setModalShow(true, { id: userId });
  };
  const handleModalClose = () => {
    setModalShow(false);
    setFormData({
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      station_code: '',
      user_type: 'E'
    });
    setEditId('');

  };

  const [gridData, setGridData] = useState([]);
  const [stationList, setStationList] = useState([]);
  const fetchStation = async () => {
    try {
      const res = await withRFSToken.post(AIRLINESTATION, { status: 'A' })
        .then(function (res) {
          const innerData = res.data.Rows;
          // setGridData(innerData);
          const transformData = innerData ? innerData.map((item) => ({
            label: item.station_code,
            value: item.station_code
          })) : []
          setStationList(transformData)
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchData = async () => {
    const payload = ruleId ? { rule_id: ruleId } : {}
    try {
      const res = await withRFSToken.post('uld-setting/get-station-list', payload)
        .then(function (res) {
          // if (res.data.response_code === 200) {
          const innerData = res.data.Rows;
          console.log("🚀 ~ .then ~ innerData:", innerData)
          // const transformedData = innerData ? innerData.map(item => ({
          //   value: item.code,
          //   label: item.code +'-'+ item.name
          // })) : [];    
          setGridData(innerData);
        });
      // } else {
      //   toast.error(res.data.response_msg)
      // }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    if (isMounted.current) return;
    // Call the fetchData function to fetch data from the API
    fetchData();
    fetchStation();
    isMounted.current = true;
  }, []);

  // const fetchDataDetails = async (id) => {
  //   try {
  //     const res = await withRFSToken.post(USERDETAILS, { user_id: id })
  //       .then(function (res) {
  //         const innerData = res.data.data;
  //         console.log("🚀 ~ .then ~ innerData:xxx", innerData)
  //         const userId = innerData.user_id;

  //         const portalAccess = innerData.portal_access;
  //         const portalAccessObject = {};
  //         if (portalAccess) {
  //           portalAccess.forEach((key) => {
  //             portalAccessObject[key] = true;
  //           });
  //           setFormData({
  //             ...innerData,
  //             station_code: innerData.port_code,
  //             portal_access: portalAccessObject
  //           });
  //           handleEditButtonClick(userId);
  //           console.log("🚀 ~ .then ~ portalAccessObject:", portalAccessObject)
  //         }

  //         return portalAccessObject;
  //         // const transformedData = innerData ? innerData.map(item => ({
  //         //   value: item.code,
  //         //   label: item.code +'-'+ item.name
  //         // })) : [];    
  //         // setStationList(innerData);
  //       });

  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };
  const gridRef = useRef(null);
  useEffect(() => {
    // console.log("🚀 ~ ExportActive ~ PPP:", gridData)
    if (gridRef.current) {

      const source = {
        datatype: 'json',
        datafields: [
          { name: 'user_id', type: 'string' },
          { name: 'contact_name', type: 'string' },
          { name: 'last_name', type: 'string' },
          { name: 'email_id', type: 'string' },
          { name: 'user_type', type: 'string' },
          { name: 'address2', type: 'string' },
          { name: 'status', type: 'string' },
          { name: 'city', type: 'string' },
          { name: 'country', type: 'string' },
          { name: 'postal_code', type: 'string' },
          { name: 'station_code', type: 'string' },
          { name: 'station_short_code', type: 'string' },
          { name: 'user_count', type: 'string' },
          { name: 'status', type: 'string' },
        ],
        localdata: gridData,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);

      const columns = [
        // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },filtertype: 'bool',
        // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },

        {
          text: 'Activities',
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + trash + '" class="row_delete" /></div>';
          },
          width: '10%',filterable:false
        },
        { text: 'Contact Name', filtertype: 'textbox', datafield: 'contact_name', width: '12%', cellclassname: '', },
        { text: 'Station Code', filtertype: 'textbox', datafield: 'station_short_code', width: '10%', cellclassname: '', },
        { text: 'Email Id', filtertype: 'textbox', datafield: 'email_id', width: '15%', cellclassname: '', },
        { text: 'Address', filtertype: 'textbox', datafield: 'address2', width: '10%', cellclassname: '', },
        // { text: 'Address2', filtertype: 'textbox', datafield: 'station_code', width: '7%' },
        { text: 'City', filtertype: 'textbox', datafield: 'city', width: '7%' },
        { text: 'Country', filtertype: 'textbox', datafield: 'country', width: '7%' },
        { text: 'Postal Code', filtertype: 'textbox', datafield: 'postal_code', width: '7%' },
        { text: 'User Count', filtertype: 'textbox', datafield: 'user_count', width: '7%' },
        { text: 'Status', filtertype: 'textbox', datafield: 'status', width: '7%' },
      ];


      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        // selectionmode: 'checkbox',
        pageable: true,
        pageSize: 10,
        pagerButtonsCount: 10,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 50,
        columnsheight: 45,
      };


      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRef.current).on('click', '.row_edit', function (row) {

        const rowDiv = window.$(this).closest('[role="row"]');


        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const id = rowData.user_id
        console.log("🚀 ~ rowDiv:", rowData)
        // fetchDataDetails(id);
        const rowBookingId = rowData.booking_id;
        setEditId(id);
        setModalShow(true);
        setFormData({
          first_name: rowData.first_name || '',
          last_name: rowData.last_name || '',
          email: rowData.email || '',
          phone_number: rowData.phone_number || '',
          station_code: rowData.station_code || '',
          user_type: rowData.user_type == 'User' ? 'E' : 'S'
        })
      });
      window.$(gridRef.current).on('click', '.row_delete', function (row) {

        const rowDiv = window.$(this).closest('[role="row"]');


        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const id = rowData.user_id
        setDeleteId(id);
        console.log("🚀 ~ rowDiv:", rowData)

        handleShowConfirmation(deleteRow);
        const rowBookingId = rowData.booking_id;


      });

    }

  }, [gridData]);

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    station_code: '',
    user_type: 'E'
  });



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData((prevData) => ({
        ...prevData,
        portal_access: {
          ...prevData.portal_access,
          [name]: checked
        }
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
    // setFormData((prevData) => ({
    //   ...prevData,
    //   // [name]: type == 'checkbox' ? { ...prevData, [value]: checked } : value
    // }));
    // console.log('202', formData);
  };
  const validateFormData = () => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Function to validate email
    const validateEmail = (email) => {
      return emailRegex.test(email);
    };
    // if (!formData.first_name) {
    //   console.log('Text input is required');
    //   toast.error('First Name must not be blank');
    //   isValid = false;
    // } else if (!formData.last_name) {
    //   console.log('Text input is required');
    //   toast.error('Last Name must not be blank');
    //   isValid = false;
    // } else if (!formData.email) {
    //   console.log('Text input is required');
    //   toast.error('Email must not be blank');
    //   isValid = false;
    // } 
    if (!validateEmail(formData.email)) {
      console.log('Invalid email address');
      toast.error('Invalid email address');
      isValid = false;
    }
    // else if (!formData.phone_number) {
    //   console.log('Text input is required');
    //   toast.error('Phone Number must not be blank');
    //   isValid = false;
    // } else
    //   if (!/^\d{10}$/.test(formData.phone_number)) {
    //     console.log('10');
    //     toast.error('Phone Number must be 10 Digits');
    //     isValid = false;
    //   } 
    else {
      return isValid;
    }
  };
  const handleSubmit = async () => {
    if (validateFormData()) {
      // You can send formData to your API endpoint here
      //   const selectedAccess = Object.entries(formData.portalAccess)
      // .filter(([key, value]) => value)
      // .map(([key]) => key);
      const stationcode = stationList.find(lst => lst.port_code == formData.station_code);
      // console.log("🚀 ~ handleSubmit ~ stationcode:", stationcode)
      // const portalAccessArray = Object.keys(formData.portal_access)
      //   .filter(key => formData.portal_access[key]);

      // Create the final data object for submission
      let finalData = {};
      if (editId) {
        finalData = {
          ...formData,
          user_id: editId,
          // port_address: stationcode.port_address,
          // portal_access: portalAccessArray
        };
      } else {
        finalData = {
          ...formData,
        };
      }

      console.log('fdaa', finalData);
      try {
        const res = await withRFSToken.post(AIRLINESAVEUSER, finalData);
        if (res.data.response_code === 200) {
          if (editId) {
            toast.success('Station Data Updated Successfully');
          } else {
            toast.success('Station Data Saved Successfully');
          }
          setFormData({ first_name: '', last_name: '', email: '', phone_number: '', station_code: '', user_type: 'E' })
          fetchData();
          handleModalClose();
          setEditId('');
        } else {
          toast.error(res.data.response_msg);
        }

      } catch (error) {
        console.error('Error sending request:', error);
      }

    }
  };
  const handleEditSubmit = async () => {
    if (validateFormData()) {
      // You can send formData to your API endpoint here
      //   const selectedAccess = Object.entries(formData.portalAccess)
      // .filter(([key, value]) => value)
      // .map(([key]) => key);
      const stationcode = stationList.find(lst => lst.port_code == formData.station_code);
      // console.log("🚀 ~ handleSubmit ~ stationcode:", stationcode)
      const portalAccessArray = Object.keys(formData.portal_access)
        .filter(key => formData.portal_access[key]);

      // Create the final data object for submission
      const finalData = {
        ...formData,
        user_id: editId,
        // port_address: stationcode.port_address,
        // portal_access: portalAccessArray
      };
      console.log('fdaa', finalData);
      // try {
      //   const res = await withRFSToken.post(SUBMITLIST, finalData);
      //   console.log("response==>", res.data);
      //   if (res.data.status === 400) {
      //     console.log('www', res.data.message)
      //     toast.error(res.data.message);
      //   } else {
      //     setFormData({ first_name: '', last_name: '', email: '', phone_number: '', station_code: '', })
      //     reloadGrid();
      //     handleModalClose();
      //     setEditId('');
      //   }

      // } catch (error) {
      //   console.error('Error sending request:', error);
      // }

    }

  };
  const handleShowConfirmation = (deleteFunction) => {
    setShowConfirmation(true);
    setDeleteFunction(() => deleteFunction);
  };
  const handleConfirmDelete = () => {
    // deleteRow(gridSelect);
    deleteFunction(deleteId)
    setShowConfirmation(false);
  };

  const handleCancelDelete = () => {
    setDeleteId('')
    setShowConfirmation(false);
  };
  const deleteRow = async (selectedId) => {

    try {
      const res = await withRFSToken.post(AIRLINEREMOVEUSER, { user_id: selectedId });
      if (res.data.response_code == 200) {
        toast.success('Station Data Removed Successfully')
        fetchData();
        setDeleteId('');
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error sending request:', error);
    }
  };

  return (
    <>
      {/* <div className="">{console.log('formData', formData)}
        <Header page_type='settings' logo_url='/Dashboard' sBackUrl='/Dashboard' />
        <div className="main-panel">

          <div className="row">
            <LeftSettings /> */}

      <div className='col-9 col-xxl-9 stting_right'>
        <div className='settingbg_right'>
          <h4>Station Setting</h4>
          <p>Set your notification preferences for when you are in or away from the dashboard.</p>
          <div className='d-flex justify-content-between'>
            <div>
              <Button variant="primary createplan" onClick={handleAddButtonClick} >
                <FontAwesomeIcon icon={faPlus} /> Add Station
              </Button>
            </div>
            <div className='rastatus'>
              <span>Status : </span>
              <Form.Select>
                <option>All</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Form.Select>
            </div>

          </div>
          <div ref={gridRef} className='bookinggrid userstting'></div>
        </div>
      </div>
      {/* </div>
        </div>
      </div> */}
      <Modal show={modalShow} centered onHide={handleModalClose} className='addfrom' >
        <Modal.Header closeButton>
          <Modal.Title>
            {editId &&
              !editId == '' ? (
              <>
                Edit Station
              </>
            ) : (
              <>
                Add Station
              </>
            )
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Form.Group as={Row} className='mb-2'>
            <Col sm="12">
              <Form.Label>Contact Name </Form.Label>
              <Form.Control type="text" name='first_name' placeholder="First Name" value={formData.first_name} onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group controlId="dropdown" className='mb-2' as={Row}>
            <Col sm='12'>
              <Form.Label>Select Station</Form.Label>
              {/* <Form.Select aria-label="Default select example" name="station_code" value={formData.station_code} onChange={handleChange}>
                  <option>Select Station</option>
                  {console.log('ddd', stationList)}
                  {stationList && stationList.map((list, index) => (
                    <option key={index} value={list.value}>{list.label}</option>
                  ))} */}
              {/* <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select> */}
              <Select
                options={stationList}
                onChange={(selected) => {
                  const updatedData = { ...formData, station_code: selected.value };
                  setFormData(updatedData);
                }}
                placeholder="Select Station"
                className='down_selct'
                name="station_code"
                value={stationList.find(option => option.value === formData.station_code)}
              />
            </Col>

          </Form.Group>

          <Form.Group as={Row} className='mb-2'>
            <Col sm="12">
              <Form.Label>Address </Form.Label>
              <Form.Control type="text" name='first_name' placeholder="First Name" value={formData.first_name} onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className='mb-2'>
            <Col sm="12">
              <Form.Label>Address 2</Form.Label>
              <Form.Control type="text" name='first_name' placeholder="First Name" value={formData.first_name} onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} className='mb-2'>
            <Col sm="6">
              <Form.Label>Email id</Form.Label>
              <Form.Control type="text" name='email' placeholder="Email id" value={formData.email} onChange={handleChange} />
            </Col>
            <Col sm="6">
              <Form.Label>Postal Code</Form.Label>
              <Form.Control type="number" maxLength='12' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }} name='phone_number' value={formData.phone_number} onChange={handleChange} placeholder="Number" />

            </Col>
          </Form.Group>


          <Form.Group as={Row} className='mb-2'>
            <Col sm="6">
              <Form.Label>City</Form.Label>
              <Form.Control type="text" name='first_name' placeholder="First Name" value={formData.first_name} onChange={handleChange} />
            </Col>
            <Col sm="6">

              <Form.Label>Country</Form.Label>
              <Form.Control type="text" placeholder="Last Name" name='last_name' value={formData.last_name} onChange={handleChange} />

            </Col>
          </Form.Group>








        </Modal.Body>
        <Modal.Footer>

          <Button variant="primary" onClick={handleSubmit}>
            {editId && !editId == '' ? 'Update' : 'Add'} Station
          </Button>
          {/* ) : (
                <Button variant="primary" onClick={handleSubmit}>
                  Add Station
                </Button>
              )
              } */}

        </Modal.Footer>
      </Modal>
      <Modal className='raintrac' show={showConfirmation} onHide={() => setShowConfirmation(false)}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h2>Confirm Delete</h2>
          <p>If you proceed with the change, Station data will be removed.
            Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDelete}>
            No
          </Button>
          <Button variant="primary" onClick={handleConfirmDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default StationSettings;